module.exports = __webpack_public_path__ + "img/png.9281c91d.svg";